import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Overview from "../components/Overview";
import Features from "../components/Features";
import Footer from "../components/Footer";
import Testimonials from "../components/Testimonials";
import AdditionalSections from "../components/AdditionalSections"

const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <Overview />
      <Features />
      <Testimonials />
      <AdditionalSections />
      <Footer />
    </div>
  );
};

export default Home;
